export class LoginWithEmail {
  constructor(authApiClient) {
    this.authApiClient = authApiClient;
  }

  execute(payload) {
    return this.authApiClient.login(payload);
  }
}

